import { Rule } from 'antd/es/form'
import { phoneValidator, yupSyncGenerator } from 'src/common/helpers'
import * as yup from 'yup'

import { strings } from '../strings'

const schema = yup.object({
  email: yup
    .string()
    .email(strings.emailValidation)
    .required(strings.requiredValidation),
  first_name: yup.string().required(strings.requiredValidation),
  last_name: yup.string().required(strings.requiredValidation),
  phone_number: phoneValidator.required(strings.requiredValidation),
})

export const yupSync: Rule = yupSyncGenerator(schema)
